import { render, staticRenderFns } from "./PaBonusIndex.vue?vue&type=template&id=2f890676"
import script from "./PaBonusIndex.vue?vue&type=script&lang=js"
export * from "./PaBonusIndex.vue?vue&type=script&lang=js"
import style0 from "./PaBonusIndex.vue?vue&type=style&index=0&id=2f890676&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports